<template lang="pug">
    .delivery-to
        z-select(
            label="Способ доставки груза"
            v-model="deal.delivery_method_to"
            :required="true"
            name="delivery_method_to"
            id="delivery_method_to"
            v-validate="'required'"
            v-bind:error="errors.first('delivery_method_to')"
            data-vv-name="delivery_method_to"
            v-bind:data-vv-as="' '"
            inline
            v-bind:disabled="blockedDeliveryMethodAndAddress"
            v-bind:dirty.sync="dirtyObj.method"
        )
            option(v-bind:value="1" v-bind:disabled="blocked") До терминала
            option(v-bind:value="2" v-on:click="deal.to_stock_id = null") До адреса клиента

        div(v-if="stocks && stocks.length && parseInt(deal.delivery_method_to) === 1")
            z-select(
                label="Склад"
                v-model="deal.to_stock_id"
                :required="true"
                name="to_stock"
                id="to_stock"
                v-validate="'required'"
                v-bind:error="errors.first('to_stock')"
                data-vv-name="to_stock"
                v-bind:data-vv-as="' '"
                v-bind:disabled="blocked"
                inline
                v-bind:dirty.sync="dirtyObj.stock"
            )
                option(v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id") {{ stock.name }}


        div(v-if="parseInt(deal.delivery_method_to) === 2")
            ZInputAutocomplete(
                v-if="deal.to_address && deal.to_address.address !== undefined"
                label="Введите точный адрес"
                display-property="unrestricted_value"
                property="unrestricted_value"
                return="unrestricted_value"
                v-model="deal.to_address.address"
                v-bind:showOnFocus="true"
                v-bind:callback="suggestAddress"
                v-bind:items="addressSuggest"
                v-bind:default="deal.to_address.address"
                v-on:select="selectAddress"
                v-on:clear="clearAddress"
                :required="true"
                id="to_address"
                name="to_address"
                data-vv-name="from_address"
                v-bind:data-vv-as="' '"
                v-validate="{'required': true}"
                v-bind:error="errors.first('from_address')"
                v-bind:dirty.sync="dirtyObj.address"
                v-bind:disabled="blockedDeliveryMethodAndAddress"
            )

            .md-layout-item
                z-select(
                    v-if="$props.payers"
                    label="Плательщик (экспедир.)"
                    v-model="deal.forwarding_payer_id_to"
                    v-bind:name="('forwarding-from-payer')"
                    v-bind:id="('forwarding-from-payer-')"
                    v-bind:disabled="blocked"
                    v-bind:inline="true"
                    v-bind:dirty.sync="dirtyObj.payer"

                    data-vv-name="forwarding_payer_id_to"
                    v-bind:data-vv-as="' '"
                    v-bind:error="errors.first('forwarding_payer_id_to')"
                )
                    option(v-for="(payer, i) in $props.payers" v-bind:disabled="!payer.id" v-bind:key="(payer.hid + '-' + i)" v-bind:value="payer.id") {{payer.name}}

            .md-layout-item
                z-input(
                    label="Цена экспедирования"
                    v-model="deal.custom_forward_price_to"
                    name="custom_forward_price_to"
                    id="custom_forward_price_to"
                    type="number"
                    v-bind:placeholder="getForwardingFullPrice()"
                    v-bind:error="errors.first('custom_forward_price_to')"
                    data-vv-name="custom_forward_price_to"
                    v-bind:data-vv-as="' '"
                    v-bind:disabled="blocked || !$props.canEditPrice"
                    inline
                    v-bind:dirty.sync="dirtyObj.forward_price_to"
                )

            .md-layout-item.static-container(v-if="deal && deal.route_list_to")
                .static-item(v-if="deal.route_list_to.date")
                    label Дата выдачи (по маршрутному листу)
                    .field {{moment(deal.route_list_to.date).tz($root.userTimezone).format('DD.MM.YYYY (DD MMMM)')}}
                .static-item(v-if="deal.route_list_to.forwarder && deal.route_list_to.forwarder.login")
                    label Экспедитор в пункте выдачи (по маршрутному листу)
                    .field {{deal.route_list_to.forwarder.login}}
        
        md-field(v-show="deal.id && deal.id != 'new' && !!deal.to_signature" v-bind:class="{ 'md-invalid': errors.has('to_signature'), 'md-has-value': !!deal.to_signature}")
            label(v-html="'Получатель ' + ' <b>(' + moment(deal.to_signature_date).tz($root.userTimezone).format('DD.MM.YYYY HH:mm') + ')</b>' ")
            wacom-signature(ref="toSignature" v-model="deal.to_signature" v-on:capture-complete="onToCapture")
        .md-layout
            .md-layout-item.md-size-50
                z-button(v-on:click="doToCapture()" v-if="deal.id && deal.id != 'new' && !$props.block" light) Подписать

        //Подпись представителя при выдаче
        wacom-signature(ref="issueSignature" v-model="deal.to_signature" v-on:capture-complete="onIssueCaptureComplete" v-on:capture-cancel="onIssueCaptureCancel" style="display: none;")
</template>
<script>
    import ZInputAutocomplete from '@/components/ZInputAutocomplete'
    import moment from "moment"
    import Properties from '@/components/Properties'
    import WacomSignature from '@/components/WacomSignature';
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    import ZButton from '@/components/ZButton';
    export default {
        name: 'delivery-to',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            block: {
                type: Boolean,
                default: false
            },
            suggestAddressCallback: {
                type: Function,
                default: () => {}
            },
            payers: {
                type: Array,
                default: []
            },
            dirty: {
                type: Boolean,
                default: false
            },
            canEditPrice: {
                type: Boolean,
                default: true
            },

            isUserHasHighPermission: {
                type: Boolean,
                default: false
            },
            isUserAgent: {
                type: Boolean,
                default: false
            },
            isUserAdmin: {
                type: Boolean,
                default: false
            },
            isUserManager: {
                type: Boolean,
                default: false
            },

            isDealCanceled: {
                type: Boolean,
                default: false
            },
            isIssueToTransfer: {
                type: Boolean,
                default: false
            },
            isEnteredToStock: {
                type: Boolean,
                default: false
            },
            isIssusedToClient: {
                type: Boolean,
                default: false
            },
        },
        components: {
            ZInputAutocomplete,
            WacomSignature,
            ZSelect,
            ZButton,
            ZInput
        },
        data() {
            return {
                parent: null,
                method: 1,
                deal: {},
                defaultAddress: {
                    id: null,
                    value: {},
                    address: null,
                    description: null,
                    type_id: 1,
                    city_id: null,
                    value: {
                        city_fias_id: null
                    }
                },
                defaultStock: {
                    id: null,
                    name: null,
                    description: null,
                    sort: 100,
                    city_id: null,
                    freight_count: 0
                },
                dirtyObj: {
                    method: false,
                    stock: false,
                    address: false,
                    forward_price_to: false,
                    payer: false
                }
            }
        },
        computed: {
            blocked() {
                // Если пользователь администратор, то он всегда может редактировать параметры назначения
                if (this.$props.isUserAdmin) return false;

                // Остальные условия сработают только для представителя и менеджера

                // Если заявка отменена, то ничего редактировать нельзя
                if (this.$props.isDealCanceled) return true;

                // Если заявка выдана клиенту и пользователь не админ, тогда он не может редактировать параметры назначения
                if (this.$props.isIssusedToClient && !this.$props.isUserAdmin) return true;

                // Если заявка была выдана на перемещение или принята с перемещения, то менять параметры назначения может только админ или менеджер
                if ((this.$props.isIssueToTransfer || this.$props.isEnteredToStock) && !this.$props.isUserAdmin && !this.isUserManager) return true;
            },
            blockedDeliveryMethodAndAddress() {
                // Если пользователь администратор, то он всегда может редактировать параметры назначения
                if (this.$props.isUserAdmin) return false;

                // Остальные условия сработают только для представителя и менеджера

                // Если заявка отменена, то ничего редактировать нельзя
                if (this.$props.isDealCanceled) return true;

                // Если заявка выдана клиенту и пользователь не админ, тогда он не может редактировать параметры назначения
                if (this.$props.isIssusedToClient && !this.$props.isUserAdmin) return true;
                
                
                if (!this.dirtyObj.address && this.deal.to_address && this.deal.to_address.address && this.deal.to_address.id)
                    return true

                // В остальных случах для менеджера и представителя заблокируется способ доставки "До склада", а "До адреса" будет активен и его можно будет выбрать
                return false;
            },
            stocks() {
                return this.$store.state.stock.to_stocks;
            },
            addressTypes() {
              return this.$store.state.address.address_types;
            },
            addressSuggest() {
                if (!this.deal.recipient || !this.deal.recipient.addresses) return [];
                else return this.deal.recipient.addresses.map(item => {
                    return {
                        id: item.id,
                        data: item.value,
                        value: item.address,
                        unrestricted_value: item.address
                    };
                });
            },
            defaultPayer() {
                if (!this.$props.payers || !this.$props.payers.length) return;
                return this.$props.payers.find(p => !!p);
            },
            isDirty() {
                return !!Object.values(this.dirtyObj).find(item => item);
            }
        },
        watch: {
            '$props.value': {
                deep: true,
                handler() {
                    this.init();
                }
            },
            '$props.payers'() {
                this.setDefaultPayer();
            },
            'deal': {
                deep: true,
                handler(deal) {
                    this.$emit('change', deal);
                    this.$emit('input', deal);
                }
            },
            'deal.delivery_method_to'(method) {
                //Метод - со склада
                if (parseInt(method) == 1) {
                    this.deal.to_address_id = null;
                    this.deal.custom_forward_price_to = null;
                    //this.deal.to_address = Object.assign({}, this.defaultAddress);
                //Метод - с адреса клиента
                } else if (parseInt(method) == 2) {
                    this.deal.to_stock_id = null;
                    //this.deal.to_stock = Object.assign({}, this.defaultStock);
                }
                this.setDefaultPayer();
            },
            'isDirty'(val) {
                if (val) this.emitDirty();
            }
        },
        methods: {
            emitDirty() {
                this.$emit('update:dirty', this.isDirty);
            },
            init() {
                this.validateClear();
                if (this.$props.value && JSON.stringify(this.$props.value) != JSON.stringify(this.deal)) this.deal = Object.assign({}, this.$props.value);
                if (!deal.delivery_method_to) deal.delivery_method_to = 1;
                this.setDefaultPayer();
            },

            setDefaultPayer() {
                if (parseInt(this.deal.delivery_method_to) === 1)
                    return this.deal.forwarding_payer_id_to = null;

                if (!this.defaultPayer)
                    return this.deal.forwarding_payer_id_to = null;

                if (this.deal.forwarding_payer_id_to) {
                    let exist = this.$props.payers.find(item => parseInt(item.id) === parseInt(this.deal.forwarding_payer_id_to));
                    if (exist) return;
                    this.deal.forwarding_payer_id_to = null;
                }

                this.deal.forwarding_payer_id_to = this.defaultPayer.id;
            },

            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
            },
            suggestAddress(string) {
                return this.suggestAddressCallback(string);
            },
            selectAddress(address, item) {
                if ((!item.id || item.id === 'new') && this.addressTypes && this.addressTypes.length) {
                    let type = this.addressTypes.find(item => item.code === 'order');
                    this.deal.to_address.type_id = type.id;
                    delete this.deal.to_address.id;
                }
                if (item.id) this.deal.to_address_id = item.id;
                else this.deal.to_address_id = 'new';

                if (item.data && item.data.city_fias_id) this.deal.to_address.value.city_fias_id = item.data.city_fias_id;
                else this.deal.to_address.value.city_fias_id = null;
            },
            clearAddress() {
                this.deal.to_address_id = null;
                this.deal.to_address    = Object.assign({}, this.defaultAddress);
            },

            getForwardingFullPrice() {
                if (
                    this.deal && this.deal.first_freight && this.deal.first_freight.full_price && 
                    this.deal.first_freight.full_price.additional && this.deal.first_freight.full_price.additional.forwarding_to
                ) return ('Текущая: ' + this.$parent.formatPrice(this.deal.first_freight.full_price.additional.forwarding_to.value)  + ' руб.');

                return '';
            },

            doIssueCapture() {
                return new Promise((resolve, reject) => {
                    if (!this.$refs || !this.$refs.issueSignature) {
                        if (reject) reject();
                        else return;
                    }

                    this.$refs.issueSignature.$emit('capture');
                    this.$once('onIssueCaptureComplete', () => {
                        this.$nextTick(() => this.onToCapture().then(() => resolve(this.deal.to_signature)));
                    });
                    this.$once('onIssueCaptureCancel', () => {
                        if (reject) reject();
                    });
                });
            },
            onIssueCaptureComplete() {
                this.$emit('onIssueCaptureComplete');
            },
            onIssueCaptureCancel() {
                this.$emit('onIssueCaptureCancel');
            },

            doToCapture() {
                if (!this.$refs || !this.$refs.toSignature) return;
                this.$refs.toSignature.$emit('capture');
            },
            onToCapture() {
                let data = {
                    deal_id: this.deal.id,
                    type: 'to_signature',
                    signature: this.deal.to_signature,
                    signature_all_freight: 1
                };
                this.$store.commit('showProgressBar', 'load-deal-card');
                return this.$store.dispatch('deals/setDealCapture', data).then(() => {
                    this.$store.commit('showSnackbar', ['Заявка и грузы успешно подписаны в пункте назначения', 6000, 'success']);
                }).finally(() => this.$store.commit('hideProgressBar', 'load-deal-card'));
            },
            validate() {
                return this.$validator.validateAll();
            }
        },
        created() {
            this.$nextTick(() => this.init());
        },
    }
</script>



// WEBPACK FOOTER //
// DeliveryTo.vue?fbca1e9c